import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const NotificationService = {
  getAllNotifications: (params) => axiosInstance.get(API_ENDPOINTS.Notification.GET_ALL, {
    params: params,
  }),
  
  createNotification: (data) => axiosInstance.post(API_ENDPOINTS.Notification.CREATE, data),

  markNotificationAsRead: (notificationId, userId) => axiosInstance.put(API_ENDPOINTS.Notification.MarkNotificationAsRead(notificationId, userId)),

  markAllNotificationsAsRead: (userId, roleName) => axiosInstance.put(API_ENDPOINTS.Notification.MarkAllNotificationsAsRead(userId, roleName)),
};

export default NotificationService;
